import styled from "styled-components";

export const Content = styled.div`
  background: ${props => props.theme?.login_bg || props.theme.main_bg};
  width: 100%;
  height: 100vh;
`;